const dpMatch = /^\/dp(\/.*)?$/;
export default function isNetlifyTrustTokenNeeded(url: string): boolean {
  return dpMatch.test(url);
}
